import { useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SettingsTabNav } from './SettingsTabNav';
import { SettingsToc } from './SettingsToc';
import { PageTransition } from '../ui/PageTransition';

export function SettingsPage() {
  const location = useLocation();
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="main-container-gdm">
      <SettingsTabNav />
      <div className="mt-8">
        <SettingsToc key={location.pathname} containerRef={contentRef} />
        <div ref={contentRef}>
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </div>
      </div>
    </div>
  );
}
